import { ErrorCode } from 'react-dropzone';

export const errorMessage = (errorCode: string) => {
  if (errorCode === ErrorCode.FileInvalidType) {
    return 'distribution:uploadAudioModal:validation:message:invalidFileType';
  }
  if (errorCode === ErrorCode.FileTooLarge) {
    return 'distribution:uploadAudioModal:validation:message:audioFileTooLong';
  }
  if (errorCode === ErrorCode.FileTooSmall) {
    return 'distribution:uploadAudioModal:validation:message:audioFileToShort';
  }
  if (errorCode === ErrorCode.TooManyFiles) {
    return 'distribution:uploadAudioModal:validation:message:tooManyFiles';
  }
  return 'distribution:uploadAudioModal:validation:message:generic';
};
